import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OrganizationService } from '../OrganizationService';

// Organization mutations
export const useCreateOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => OrganizationService.createOrganization(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
    },
  });
};

export const useUpdateOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }) =>
      OrganizationService.updateOrganization(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
    },
  });
};

// RM mutations
export const useAssignRM = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationId, data }) =>
      OrganizationService.assignRM(organizationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      queryClient.invalidateQueries({ queryKey: ['organizations', 'rm-list'] });
    },
  });
};

export const useRegisterOrganizationUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => OrganizationService.registerOrganizationUser(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organization-users'] });
    },
  });
};
